import {
  Component,
  OnInit,
  Inject,
  Optional,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  OnDestroy,
  SecurityContext,
} from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogConfig,
} from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'src/app/common/services/message.service';
import { ApiService } from 'src/app/common/services/api.service';
import { UtilService } from 'src/app/util/util.service';
import { CommonService } from 'src/app/common/services/common.service';
import { DateService } from 'src/app/common/services/date.service';
import { HttpHeaders } from '@angular/common/http';
import { EventTrackerService } from 'src/app/common/services/event-tracker.service';
import { CashierConfirmationComponent } from 'src/app/common/components/cashier-confirmation/cashier-confirmation.component';
import { CurrencyService } from 'src/app/util/currency.service';
import { TranslateService } from '@ngx-translate/core';
import { FormaterService } from 'src/app/common/services/formater.service';
import { CashierActionType } from '../../models/enums/invoice.enum';
import { CROSS } from 'src/defaultImages.js';
import { DomSanitizer } from '@angular/platform-browser';
import { BillingCountersDataService } from 'src/app/common/services/billing-counters-data.service';


@Component({
  selector: 'app-update-cashier',
  templateUrl: './update-cashier.component.html',
  styleUrls: [
    '../../../common/components/update-cash/update-cash.component.css',
    './update-cashier.component.css',
  ],
})
export class UpdateCashierComponent implements OnInit, OnDestroy {
  images = { 
    CROSS: CROSS,
  };
  Currency;
  @ViewChild('floatcount', { static: false }) floatcount: ElementRef;
  now = new Date();
  cashCollectForm: FormGroup;
  reasons = [];
  selectedOption: string;
  btnDisabled: boolean = false;
  reason_text: string;
  cashCountStatus: boolean = false;
  closeCashierReasons = [{ id: 'EOD update', name: 'EOD Update' }];
  openCashierReasons = [
    { id: 'opening cash float', name: 'Opening Cash Float' },
  ];
  en_buttonStatus = {
    '0.05': { active: 1, counter: 0, total: 0, key: 'zero_point_zero_five' },
    '0.10': { active: 1, counter: 0, total: 0, key: 'zero_point_ten' },
    '0.20': { active: 1, counter: 0, total: 0, key: 'zero_point_twenty' },
    '0.50': { active: 1, counter: 0, total: 0, key: 'zero_point_fifty' },
    '1': { active: 1, counter: 0, total: 0, key: 'one' },
    '5': { active: 1, counter: 0, total: 0, key: 'five' },
    '10': { active: 1, counter: 0, total: 0, key: 'ten' },
    '20': { active: 1, counter: 0, total: 0, key: 'twenty' },
    '100': { active: 1, counter: 0, total: 0, key: 'hundred' },
    '50': { active: 1, counter: 0, total: 0, key: 'fifty' },
  };

  id_buttonStatus = {
    '100': { active: 1, counter: 0, total: 0, key: 'hundred' },
    '200': { active: 1, counter: 0, total: 0, key: 'two_hundred' },
    '500': { active: 1, counter: 0, total: 0, key: 'five_hundred'},
    '1000': { active: 1, counter: 0, total: 0, key: 'thousand' },
    '2000': { active: 1, counter: 0, total: 0, key: 'two_thousand' },
    '5000': { active: 1, counter: 0, total: 0, key: 'five_thousand' },
    '10000': { active: 1, counter: 0, total: 0, key: 'ten_thousand' },
    '20000': { active: 1, counter: 0, total: 0, key: 'twenty_thousand' },
    '50000': { active: 1, counter: 0, total: 0, key: 'fifty_thousand' },
    '100000': { active: 1, counter: 0, total: 0, key: 'one_lakh' }
  };

  en_denominations = ['0.05', '0.10', '0.20', '0.50', '1', '5', '10', '20', '50', '100'];
  id_denominations = ['100', '200', '500', '1000', '2000', '5000', '10000', '20000', '50000', '100000'];

  denominations = [];
  buttonStatus: any;
  isLoading: boolean = false;
  subscription;
  translationText;
  billingCounterName: string = '';
  billingCounterInfo: string = '';

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<CashierConfirmationComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private messageService: MessageService,
    private apiService: ApiService,
    private util: UtilService,
    private commonService: CommonService,
    private ref: ChangeDetectorRef,
    private _eventTracker: EventTrackerService,
    private curr: CurrencyService,
    public translateService: TranslateService,
    public format: FormaterService,
    private _sanitizer: DomSanitizer,
    private _counterDataService: BillingCountersDataService,
    private _dateService: DateService
  ) {
    this.Currency = this.curr.getCurrency();
  }
  setType(type) {
    if (type == 'close-cashier') {
      this.reasons = this.closeCashierReasons;
    } else if (type == 'open-cashier') {
      this.reasons = this.openCashierReasons;
    }
  }
  ngOnInit() {
    if (this.Currency === 'RM') {
      this.denominations = this.en_denominations;
      this.buttonStatus = this.en_buttonStatus;
    } else if (this.Currency === 'Rp') {
      this.denominations = this.id_denominations;
      this.buttonStatus = this.id_buttonStatus;
    }
    this.subscription = this.translateService
      .get(['REPORTS'])
      .subscribe((translation) => {
        this.translationText = translation?.REPORTS || {};
        this.closeCashierReasons = [
          { id: 'EOD update', name: this.translationText.EOD_UPDATE },
        ];
        this.openCashierReasons = [
          { id: 'opening cash float', name: this.translationText.OPENING_CASH },
        ];
        this.setType(this.data.type);
      });
    this.cashCollectForm = this.fb.group({
      staff_name: ['', Validators.required],
      amount: ['', Validators.required],
    });
    this.setRadio(this.reasons && this.reasons[0] ? this.reasons[0].id : null);
    this.getBillingCounterName();
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private getBillingCounterName(): void {
    this.subscription.add(
      this._counterDataService
        .getMappedBillingCounterName()
        .subscribe((mappedCounterName) => {
          this.billingCounterName = mappedCounterName;
          if (this.billingCounterName) {
            const subHeadingType =
              this.data?.type === 'close-cashier'
                ? 'CLOSING_CASHIER'
                : 'OPENING_CASHIER';
            this.setSubHeading(subHeadingType);
          }
        })
    );
  }

  cancel_clicked() {
    this.dialogRef.close({ data: 'closed' });
  }
  setRadio(id) {
    this.selectedOption = id;
  }
  changes(e) {
    return e.charCode >= 46 && e.charCode <= 57 && e.charCode !== 47;
  }
  save_clicked() {
    this.cashCollectForm.markAllAsTouched();
    if (this.cashCountStatus && this.floatcount.nativeElement.value === '') {
      this.messageService.showError(this.translationText.ENTER_AMOUNT);
      return false;
    }
    if (this.cashCollectForm.valid) {
      // this.btnDisabled = true;
      this.isLoading = true;
      const form = this.cashCollectForm.value;
      const payload = {
        restaurant_id: this.data.restaurant_id,
        type: this.data.type,
        staff_name: form.staff_name,
        amount: this.format.formatMy(this.floatcount.nativeElement.value),
      };
      if (this.data.type == 'close-cashier')
        payload['date'] = this._dateService.getFormatedDate(new Date());
      if (this.selectedOption == 'custom') {
        if (
          !(
            this.reason_text == '' ||
            this.reason_text == null ||
            this.reason_text == undefined
          )
        )
          payload['reason'] = this.reason_text;
        else {
          this.isLoading = false;
          this.messageService.info(
            `${this.translationText.ENTER_A_REASON_FOR || 'Enter a reason for'} ${this.data.type == 'cashier-close'
            ? (this.translationText.CLOSE_CASHIER || 'Close Cashier')
            : (this.translationText.OPEN_CASHIER || 'Open Cashier')
            } !`
          );
          this.btnDisabled = false;
          return;
        }
      } else payload['reason'] = this.selectedOption;

      if(this.cashCountStatus){
        payload['cash_count_enabled'] = 1;
        payload['denominations'] = this.processCashCountingDetails();
      }

      let httpOptions: { headers } = {
        headers: new HttpHeaders({
          Authorization: `Bearer ${localStorage.getItem('temp_access_token')
            ? localStorage.getItem('temp_access_token')
            : localStorage.getItem('token')
            }`,
        }),
      };
      payload['device_id']= this.util.getDeviceUID();

      // this.openCashTallyModal();
      this.apiService.addCashDetails(payload).subscribe(
        (response) => {
          this.isLoading = false;

          if (response.statusCode === 201) {
            // Send data to React
            if (
              this.util.cashRegistryEnabled() &&
              !(
                this.data.type === 'close-cashier' &&
                (response.data || {}).cash_tallied === 0
              )
            ) {
              const isMultiCashDrawerEnabled = this.util.isMultiCashDrawerEnabled();
              const deviceId = this.util.getDeviceUID();
              const data = {
                restaurant_id: this.data.restaurant_id,
                txn_id: response.data.txn_id,
                action: this.data.type,
                ...(isMultiCashDrawerEnabled && { device_id: deviceId }),
              };
              this.util.send_data_to_react(data, this.data.type);
              if (this.data.type !== CashierActionType.closeCashier) {
                this.util.openCashDrawer();
              }
              this.util.openCashDrawerPrintReceipt(
                {
                  restaurant_id: this.data.restaurant_id,
                  txn_id: response.data.txn_id,
                },
                this.data.type
              );
            }
            this.messageService.showSuccess(response.data.message);
            if (
              this.data.type === 'close-cashier' &&
              (response.data || {}).cash_tallied === 1
            )
              this.openCashierReportModal();
            else if (
              this.data.type === 'close-cashier' &&
              (response.data || {}).cash_tallied === 0
            ) {
              let cashTallyData = [
                {
                  name: this.translationText.EXPECTED_CASH_IN_DRAWER,
                  amount: (response.data || {}).cash_in_drawer_text || 0
                },
                {
                  name: this.translationText.ACTUAL_CASH_IN_DRAWER,
                  amount: (response.data || {}).actual_cash_in_drawer_text || 0
                },
                {
                  name: this.translationText.EXCESS_SHORT_CASH,
                  amount: (response.data || {}).excess_short_cash_text || 0
                },
              ];
              this.openCashTallyModal(cashTallyData, payload);
            } else {
              this.commonService.sendMessage({ data: 'refresh', success: 1 });
            }
            if (
              !(
                this.data.type === 'close-cashier' &&
                (response.data || {}).cash_tallied === 0
              )
            )
              this.dialogRef.close({ data: 'success' });
            this.btnDisabled = false;
            localStorage.setItem('temp_access_token', null);
          }
        },
        (error) => {
          this.messageService.showError(error.error.message);
          this.isLoading = false;
          this.dialogRef.close({ data: 'closed' });
          this.btnDisabled = false;
          localStorage.setItem('temp_access_token', null);
        }
      );

      let eventName = '';
      this.data.type === 'close-cashier'
        ? (eventName = 'CLOSE_CASHIER_DONE')
        : (eventName = 'OPEN_CASHIER_DONE');
      this._eventTracker.easyeat_track_event(eventName, {
        'STAFF NAME': form.staff_name,
        AMOUNT: +this.format.formatMy(this.floatcount.nativeElement.value),
        REASON:
          this.selectedOption === 'custom'
            ? this.reason_text
            : this.selectedOption,
      });

      // if(this.data.type == 'close-cashier') this.openCashierReportModal();
    } else
      this.messageService.showError(this.translationText.FILL_REQUIRED_FIELDS || 'Fill in the required fields!');
  }
  openCashierReportModal() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    const dialogRef = this.dialog.open(CashierConfirmationComponent, {
      backdropClass: 'backdrop',
      maxHeight: '90vh',
      data: {
        type: 'cashier-report',
        restaurant_id: this.data.restaurant_id,
      },
      maxWidth: '100vw',
    });
    // this.dialogRef.close({data: 'closed'});
    dialogRef.afterClosed().subscribe((result: any) => { });
  }
  buttonGroupActive(item) {
    this.buttonStatus[item].active = 1;
    this.increment(item);
  }
  increment(item) {
    this.buttonStatus[item].counter += 1;
    this.buttonStatus[item].total =
      parseFloat(item) * this.buttonStatus[item].counter;
    // this.totalSum();
    this.sum(item, 'add');
  }
  decrement(item) {
    // if(this.buttonStatus[item].counter > 1){
    this.buttonStatus[item].counter -= 1;
    this.buttonStatus[item].total =
      parseFloat(item) * this.buttonStatus[item].counter;
    // this.totalSum();
    this.sum(item, 'subtract');
    // }else this.resetButton(item);
  }
  resetButton(item) {
    this.buttonStatus[item].total = 0;
    this.buttonStatus[item].counter = 0;
    this.buttonStatus[item].active = 0;
    // this.totalSum();
    // this.sum(item, "subtract");
  }
  // totalSum() {
  //   let sum = 0;
  //   for (let x in this.buttonStatus) {
  //     sum += this.buttonStatus[x].total;
  //   }
  //   this.floatcount.nativeElement.value = Number(
  //     (Math.round(sum * 100) / 100).toFixed(2)
  //   );
  //   this.cashCollectForm.controls["amount"].setValue(
  //     this.floatcount.nativeElement.value
  //   );
  // }
  sum(item, operand) {
    if (this.floatcount.nativeElement.value === '')
      this.floatcount.nativeElement.value = 0;
    let x = Number((Math.round(0 * 100) / 100).toFixed(2));
    // if (operand === "add")
    //   x += Number((Math.round(item * 100) / 100).toFixed(2));
    // else if (operand === "subtract")
    //   x -= Number((Math.round(item * 100) / 100).toFixed(2));

    let sum = 0;
    for (let x in this.buttonStatus) {
      sum += this.buttonStatus[x].total;
    }
    x += sum;

    this.cashCollectForm.controls['amount'].setValue(
      this.format.formatNo((Math.round(x * 100) / 100).toFixed(2))
    );
    this.ref.detectChanges();
  }
  validate(e) {
    //   if (e === '') {
    //     for (let x in this.buttonStatus) {
    //       this.buttonStatus[x].total = 0;
    //       this.buttonStatus[x].counter = 0;
    //       this.buttonStatus[x].active = 0;
    //     }
    //   }
    // }
    // var t = e.value;
    // e.value = (t.indexOf(".") >= 0) ? (t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)) : t;
    // e.value = Number((Math.floor(e.value * 100) / 100).toFixed(2));
  }
  inputchanges(e) {
    return e.charCode >= 44 && e.charCode <= 57 && e.charCode !== 47;
  }
  keydownChanges(e) {
    if (e.keyCode === 8) {
      for (let x in this.buttonStatus) {
        this.buttonStatus[x].total = 0;
        this.buttonStatus[x].counter = 0;
        this.buttonStatus[x].active = 1;
      }
    }
  }
  isNumberKey(evt) {
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
    return true;
  }
  onBlur(e, item) {
    if (e == '' || e == undefined || e == null) {
      this.buttonStatus[item].counter = 0;
    }
    this.ref.detectChanges();
  }
  onValueChange(e, item) {
    if (e === null) this.buttonStatus[item].counter = 0;
    else this.buttonStatus[item].counter = e;
    this.buttonStatus[item].total =
      parseFloat(item) * this.buttonStatus[item].counter;
    this.sum(item, 'manual_input');
  }
  cashCountToggleChange(e) {
    if (e.checked) this.cashCollectForm.controls['amount'].disable();
    else this.cashCollectForm.controls['amount'].enable();
    this.cashCountStatus = e.checked;
  }

  async openCashTallyModal(cashTallyData, payload) {
    const { CashTallyComponent } = await import(
      /* webpackPrefetch: true */ '../cash-tally/cash-tally.component'
    );
    const dialogRef = this.dialog.open(CashTallyComponent, {
      maxHeight: '90vh',
      data: {
        restaurant_id: this.data.restaurant_id,
        cashNotTalliedData: cashTallyData,
        closeCashierPayload: payload,
        type: 'close-cashier'
      },
      maxWidth: '100vw',
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if ((result || {}).data === 'force_cash_tallied') {
        this.dialogRef.close({ data: 'closed' });
      }
    });
  }

  processCashCountingDetails(){
    let output = [];
    this.denominations.forEach(x =>{
      output.push({
        key: this.buttonStatus[x].key,
        value: this.format.formatNo(Number(x)),
        count: this.buttonStatus[x].counter
      });
    });
    return output;
  }

  private setSubHeading(translationString: string): void {
    const counterSubHeading = this.translationText[translationString]?.replace(
      '{{billingCounterName}}',
      this.billingCounterName
    );
    this.sanitizeHtml(counterSubHeading);
  }
  private sanitizeHtml(html: string): void {
    this.billingCounterInfo = this._sanitizer.sanitize(
      SecurityContext.HTML,
      html
    );
  }
}
